import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { userQuery } from '../../../core/authentication/queries';
import { roadSectionsQuery } from '../../../core/reference/queries';
import { useAppSelector } from '../../../types';
import { GenerateReference } from './GenerateReference';
import { EmptyReference, TextInformation, Title } from './styles';

// Component used only if referenceList is empty but will be implemented later
export const EmptyReferenceList: FC = () => {
    const { t } = useTranslation();
    const user = useAppSelector(userQuery);
    // This overlay also shows when a filter hides every row; only a really empty référentiel offers the generation.
    const isReferenceEmpty = useAppSelector(roadSectionsQuery).length === 0;

    return (
        <EmptyReference>
            <TextInformation>
                {t('reference.welcomeMessage')} {user?.lastName} {user?.firstName} !
            </TextInformation>
            <Title>{t('reference.emptyReference')}</Title>
            {isReferenceEmpty && (
                <>
                    <TextInformation>{t('reference.generation.emptyHint')}</TextInformation>
                    <GenerateReference />
                </>
            )}
        </EmptyReference>
    );
};
